import { Component, Module } from "app/decorators";

import _ from "lodash";
import angular from "angular";

import tpl from "./hide-customer.button.html";

@Module({
  name: "app.directives.hide-customer.button.component",
})
@Component({
  selector: "blnd-hide-customer-button",
  template: tpl,
  bindings: {
    ngModel: "=",
    ngDisabled: "=?",
    type: "@",
    multiple: "=?",
    table: "<",
  },
})
export default class C {
  constructor($growl, UserService, $stateParams, $element, R, Modal) {
    "ngInject";

    this.$growl = $growl;
    this.$element = $element;
    this.customerId = $stateParams.customerId
    this.$user = UserService.$user;
    this.R = R;
    this.Modal = Modal;
    this.multiple = this.multiple || false;
    this.ngDisabled = this.ngDisabled || false;
    this.loading = false;
    this.isHidden = this.$user.hidden_customers.includes(parseInt(this.customerId))
  }

  $onDestroy() {
    this.$element.remove();
    this.$element = null;
  }

  hideCustomer() {
    this.loading = true;
    this.$user
      .patch({ hidden_customers: this.customerId })
      .then(
        (response) => {
          angular.extend(this.$user, response);
          this.$growl.success("Status Changed!");
        },
        (response) => {
          if (response.status === 500) {
            this.$growl.error(response.data.detail);
          }
        }
      )
      .finally(() => (window.location.replace("customers"), this.loading = false));
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/hide-customer.button/component.js